import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { ToastContainer } from "../../context/ToastContext";

const Layout = ({ children }) => {
  return (
    <>
      <Navbar />
      <main
        className="main-content"
        style={{ minHeight: "calc(100vh - 70px)", marginTop: "70px" }}
      >
        {children}
      </main>
      <Footer />
      <ToastContainer />
    </>
  );
};

export default Layout;